module.exports = __webpack_public_path__ + "static/media/LELE04.aba3d4b5.jpg";